import { createComponent } from '@lit/react';
import React from 'react';
import { SDSDetails } from '../sds-details/sds-details';
import { SheriffEventName } from './types';

export const SDSDetailsWrapper = createComponent({
	tagName: 'sds-details',
	elementClass: SDSDetails,
	react: React,
	events: {
		onToggle: 'sds-toggle' as SheriffEventName,
	},
});
